import React from "react";
import { NestedRoutes } from "./NestedRoutes";
import { routes } from "./routes";

export const Routes = () => <NestedRoutes routes={routes} />;
